export const PERU_LOCATIONS = [
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Chachapoyas',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Asuncion',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Balsas',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Cheto',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Chiliquin',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Chuquibamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Granada',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Huancas',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'La Jalca',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Leimebamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Levanto',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Magdalena',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Mariscal Castilla',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Molinopampa',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Montevideo',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Olleros',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Quinjalca',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'San Francisco de Daguas',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'San Isidro de Maino',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Soloco',
  },
  {
    dep: 'Amazonas',
    prov: 'Chachapoyas',
    dist: 'Sonche',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'Bagua',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'Aramango',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'Copallin',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'El Parco',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'Imaza',
  },
  {
    dep: 'Amazonas',
    prov: 'Bagua',
    dist: 'La Peca',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Jumbilla',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Chisquilla',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Churuja',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Corosha',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Cuispes',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Florida',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Jazan',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Recta',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'San Carlos',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Shipasbamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Valera',
  },
  {
    dep: 'Amazonas',
    prov: 'Bongara',
    dist: 'Yambrasbamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Condorcanqui',
    dist: 'Nieva',
  },
  {
    dep: 'Amazonas',
    prov: 'Condorcanqui',
    dist: 'El Cenepa',
  },
  {
    dep: 'Amazonas',
    prov: 'Condorcanqui',
    dist: 'Rio Santiago',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Lamud',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Camporredondo',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Cocabamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Colcamar',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Conila',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Inguilpata',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Longuita',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Lonya Chico',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Luya',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Luya Viejo',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Maria',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Ocalli',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Ocumal',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Pisuquia',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Providencia',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'San Cristobal',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'San Francisco del Yeso',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'San Jeronimo',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'San Juan de Lopecancha',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Santa Catalina',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Santo Tomas',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Tingo',
  },
  {
    dep: 'Amazonas',
    prov: 'Luya',
    dist: 'Trita',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'San Nicolas',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Chirimoto',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Cochamal',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Huambo',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Limabamba',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Longar',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Mariscal Benavides',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Milpuc',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Omia',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Totora',
  },
  {
    dep: 'Amazonas',
    prov: 'Rodriguez de Mendoza',
    dist: 'Vista Alegre',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Bagua Grande',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Cajaruro',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Cumba',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'El Milagro',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Jamalca',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Lonya Grande',
  },
  {
    dep: 'Amazonas',
    prov: 'Utcubamba',
    dist: 'Yamon',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Huaraz',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Cochabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Colcabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Huanchay',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Independencia',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Jangas',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'La Libertad',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Olleros',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Pampas Grande',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Pariacoto',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Pira',
  },
  {
    dep: 'Ancash',
    prov: 'Huaraz',
    dist: 'Tarica',
  },
  {
    dep: 'Ancash',
    prov: 'Aija',
    dist: 'Aija',
  },
  {
    dep: 'Ancash',
    prov: 'Aija',
    dist: 'Coris',
  },
  {
    dep: 'Ancash',
    prov: 'Aija',
    dist: 'Huacllan',
  },
  {
    dep: 'Ancash',
    prov: 'Aija',
    dist: 'La Merced',
  },
  {
    dep: 'Ancash',
    prov: 'Aija',
    dist: 'Succha',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'Llamellin',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'Aczo',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'Chaccho',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'Chingas',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'Mirgas',
  },
  {
    dep: 'Ancash',
    prov: 'Antonio Raymondi',
    dist: 'San Juan de Rontoy',
  },
  {
    dep: 'Ancash',
    prov: 'Asuncion',
    dist: 'Chacas',
  },
  {
    dep: 'Ancash',
    prov: 'Asuncion',
    dist: 'Acochaca',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Chiquian',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Abelardo Pardo Lezameta',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Antonio Raymondi',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Aquia',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Cajacay',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Canis',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Colquioc',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Huallanca',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Huasta',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Huayllacayan',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'La Primavera',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Mangas',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Pacllon',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'San Miguel de Corpanqui',
  },
  {
    dep: 'Ancash',
    prov: 'Bolognesi',
    dist: 'Ticllos',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Carhuaz',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Acopampa',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Amashca',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Anta',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Ataquero',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Marcara',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Pariahuanca',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'San Miguel de Aco',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Shilla',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Tinco',
  },
  {
    dep: 'Ancash',
    prov: 'Carhuaz',
    dist: 'Yungar',
  },
  {
    dep: 'Ancash',
    prov: 'Carlos Fermin Fitzcarrald',
    dist: 'San Luis',
  },
  {
    dep: 'Ancash',
    prov: 'Carlos Fermin Fitzcarrald',
    dist: 'San Nicolas',
  },
  {
    dep: 'Ancash',
    prov: 'Carlos Fermin Fitzcarrald',
    dist: 'Yauya',
  },
  {
    dep: 'Ancash',
    prov: 'Casma',
    dist: 'Casma',
  },
  {
    dep: 'Ancash',
    prov: 'Casma',
    dist: 'Buena Vista Alta',
  },
  {
    dep: 'Ancash',
    prov: 'Casma',
    dist: 'Comandante Noel',
  },
  {
    dep: 'Ancash',
    prov: 'Casma',
    dist: 'Yautan',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Corongo',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Aco',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Bambas',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Cusca',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'La Pampa',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Yanac',
  },
  {
    dep: 'Ancash',
    prov: 'Corongo',
    dist: 'Yupan',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Huari',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Anra',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Cajay',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Chavin de Huantar',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Huacachi',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Huacchis',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Huachis',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Huantar',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Masin',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Paucas',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Ponto',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Rahuapampa',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Rapayan',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'San Marcos',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'San Pedro de Chana',
  },
  {
    dep: 'Ancash',
    prov: 'Huari',
    dist: 'Uco',
  },
  {
    dep: 'Ancash',
    prov: 'Huarmey',
    dist: 'Huarmey',
  },
  {
    dep: 'Ancash',
    prov: 'Huarmey',
    dist: 'Cochapeti',
  },
  {
    dep: 'Ancash',
    prov: 'Huarmey',
    dist: 'Culebras',
  },
  {
    dep: 'Ancash',
    prov: 'Huarmey',
    dist: 'Huayan',
  },
  {
    dep: 'Ancash',
    prov: 'Huarmey',
    dist: 'Malvas',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Caraz',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Huallanca',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Huata',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Huaylas',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Mato',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Pamparomas',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Pueblo Libre',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Santa Cruz',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Santo Toribio',
  },
  {
    dep: 'Ancash',
    prov: 'Huaylas',
    dist: 'Yuracmarca',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Piscobamba',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Casca',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Eleazar Guzman Barron',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Fidel Olivas Escudero',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Llama',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Llumpa',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Lucma',
  },
  {
    dep: 'Ancash',
    prov: 'Mariscal Luzuriaga',
    dist: 'Musga',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Ocros',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Acas',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Cajamarquilla',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Carhuapampa',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Cochas',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Congas',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Llipa',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'San Cristobal de Rajan',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'San Pedro',
  },
  {
    dep: 'Ancash',
    prov: 'Ocros',
    dist: 'Santiago de Chilcas',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Cabana',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Bolognesi',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Conchucos',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Huacaschuque',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Huandoval',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Lacabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Llapo',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Pallasca',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Pampas',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Ancash',
    prov: 'Pallasca',
    dist: 'Tauca',
  },
  {
    dep: 'Ancash',
    prov: 'Pomabamba',
    dist: 'Pomabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Pomabamba',
    dist: 'Huayllan',
  },
  {
    dep: 'Ancash',
    prov: 'Pomabamba',
    dist: 'Parobamba',
  },
  {
    dep: 'Ancash',
    prov: 'Pomabamba',
    dist: 'Quinuabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Recuay',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Catac',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Cotaparaco',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Huayllapampa',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Llacllin',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Marca',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Pampas Chico',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Pararin',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Tapacocha',
  },
  {
    dep: 'Ancash',
    prov: 'Recuay',
    dist: 'Ticapampa',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Chimbote',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Caceres del Peru',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Coishco',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Macate',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Moro',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Nepeña',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Samanco',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Santa',
  },
  {
    dep: 'Ancash',
    prov: 'Santa',
    dist: 'Nuevo Chimbote',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Sihuas',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Acobamba',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Alfonso Ugarte',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Cashapampa',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Chingalpo',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Huayllabamba',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Quiches',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Ragash',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'San Juan',
  },
  {
    dep: 'Ancash',
    prov: 'Sihuas',
    dist: 'Sicsibamba',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Yungay',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Cascapara',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Mancos',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Matacoto',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Quillo',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Ranrahirca',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Shupluy',
  },
  {
    dep: 'Ancash',
    prov: 'Yungay',
    dist: 'Yanama',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Abancay',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Chacoche',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Circa',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Curahuasi',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Huanipaca',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Lambrama',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Pichirhua',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'San Pedro de Cachora',
  },
  {
    dep: 'Apurimac',
    prov: 'Abancay',
    dist: 'Tamburco',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Andahuaylas',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Andarapa',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Chiara',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Huancarama',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Huancaray',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Huayana',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Kishuara',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Pacobamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Pacucha',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Pampachiri',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Pomacocha',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'San Antonio de Cachi',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'San Jeronimo',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'San Miguel de Chaccrampa',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Santa Maria de Chicmo',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Talavera',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Tumay Huaraca',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Turpo',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Kaquiabamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Andahuaylas',
    dist: 'Jose Maria Arguedas',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Antabamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'El Oro',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Huaquirca',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Juan Espinoza Medrano',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Oropesa',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Pachaconas',
  },
  {
    dep: 'Apurimac',
    prov: 'Antabamba',
    dist: 'Sabaino',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Chalhuanca',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Capaya',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Caraybamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Chapimarca',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Colcabamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Cotaruse',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Huayllo',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Justo Apu Sahuaraura',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Lucre',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Pocohuanca',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'San Juan de Chacña',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Sañayca',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Soraya',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Tapairihua',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Tintay',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Toraya',
  },
  {
    dep: 'Apurimac',
    prov: 'Aymaraes',
    dist: 'Yanaca',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Tambobamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Cotabambas',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Coyllurqui',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Haquira',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Mara',
  },
  {
    dep: 'Apurimac',
    prov: 'Cotabambas',
    dist: 'Challhuahuacho',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Chuquibambilla',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Curpahuasi',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Gamarra',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Huayllati',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Mamara',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Micaela Bastidas',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Pataypampa',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Progreso',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'San Antonio',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Turpay',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Vilcabamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Virundo',
  },
  {
    dep: 'Apurimac',
    prov: 'Grau',
    dist: 'Curasco',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Chincheros',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Anco_Huallo',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Cocharcas',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Huaccana',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Ocobamba',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Ongoy',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Uranmarca',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Ranracancha',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Rocchacc',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'El Porvenir',
  },
  {
    dep: 'Apurimac',
    prov: 'Chincheros',
    dist: 'Los Chankas',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Arequipa',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Alto Selva Alegre',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Cayma',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Cerro Colorado',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Characato',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Chiguata',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Jacobo Hunter',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'La Joya',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Mariano Melgar',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Miraflores',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Mollebaya',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Paucarpata',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Pocsi',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Polobaya',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Quequeña',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Sabandia',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Sachaca',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'San Juan de Siguas',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'San Juan de Tarucani',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Santa Isabel de Siguas',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Santa Rita de Siguas',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Socabaya',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Tiabaya',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Uchumayo',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Vitor',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Yanahuara',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Yarabamba',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Yura',
  },
  {
    dep: 'Arequipa',
    prov: 'Arequipa',
    dist: 'Jose Luis Bustamante Y Rivero',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Camana',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Jose Maria Quimper',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Mariano Nicolas Valcarcel',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Mariscal Caceres',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Nicolas de Pierola',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Ocoña',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Quilca',
  },
  {
    dep: 'Arequipa',
    prov: 'Camana',
    dist: 'Samuel Pastor',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Caraveli',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Acari',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Atico',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Atiquipa',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Bella Union',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Cahuacho',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Chala',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Chaparra',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Huanuhuanu',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Jaqui',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Lomas',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Quicacha',
  },
  {
    dep: 'Arequipa',
    prov: 'Caraveli',
    dist: 'Yauca',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Aplao',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Andagua',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Ayo',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Chachas',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Chilcaymarca',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Choco',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Huancarqui',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Machaguay',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Orcopampa',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Pampacolca',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Tipan',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Uñon',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Uraca',
  },
  {
    dep: 'Arequipa',
    prov: 'Castilla',
    dist: 'Viraco',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Chivay',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Achoma',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Cabanaconde',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Callalli',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Caylloma',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Coporaque',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Huambo',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Huanca',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Ichupampa',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Lari',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Lluta',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Maca',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Madrigal',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'San Antonio de Chuca',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Sibayo',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Tapay',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Tisco',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Tuti',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Yanque',
  },
  {
    dep: 'Arequipa',
    prov: 'Caylloma',
    dist: 'Majes',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Chuquibamba',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Andaray',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Cayarani',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Chichas',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Iray',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Rio Grande',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Salamanca',
  },
  {
    dep: 'Arequipa',
    prov: 'Condesuyos',
    dist: 'Yanaquihua',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Mollendo',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Cocachacra',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Dean Valdivia',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Islay',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Mejia',
  },
  {
    dep: 'Arequipa',
    prov: 'Islay',
    dist: 'Punta de Bombon',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Cotahuasi',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Alca',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Charcana',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Huaynacotas',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Pampamarca',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Puyca',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Quechualla',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Sayla',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Tauria',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Tomepampa',
  },
  {
    dep: 'Arequipa',
    prov: 'La Union',
    dist: 'Toro',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Ayacucho',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Acocro',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Acos Vinchos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Carmen Alto',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Chiara',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Ocros',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Pacaycasa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Quinua',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'San Jose de Ticllas',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'San Juan Bautista',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Santiago de Pischa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Socos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Tambillo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Vinchos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Jesus Nazareno',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huamanga',
    dist: 'Andres Avelino Caceres Dorregaray',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Cangallo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Chuschi',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Los Morochucos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Maria Parado de Bellido',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Paras',
  },
  {
    dep: 'Ayacucho',
    prov: 'Cangallo',
    dist: 'Totos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanca Sancos',
    dist: 'Huanca Sancos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanca Sancos',
    dist: 'Carapo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanca Sancos',
    dist: 'Sacsamaarca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanca Sancos',
    dist: 'Santiago de Lucanamarca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Huanta',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Ayahuanco',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Huamanguilla',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Iguain',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Luricocha',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Santillana',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Sivia',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Llochegua',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Canayre',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Uchuraccay',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Pucacolpa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Huanta',
    dist: 'Chaca',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'San Miguel',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Anco',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Ayna',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Chilcas',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Chungui',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Luis Carranza',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Tambo',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Samugari',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Anchihuay',
  },
  {
    dep: 'Ayacucho',
    prov: 'La Mar',
    dist: 'Oronccoy',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Puquio',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Aucara',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Cabana',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Carmen Salcedo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Chaviña',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Chipao',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Huac-Huas',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Laramate',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Leoncio Prado',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Llauta',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Lucanas',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Ocaña',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Otoca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Saisa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'San Cristobal',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'San Juan',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'San Pedro',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'San Pedro de Palco',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Sancos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Santa Ana de Huaycahuacho',
  },
  {
    dep: 'Ayacucho',
    prov: 'Lucanas',
    dist: 'Santa Lucia',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Coracora',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Chumpi',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Coronel Castañeda',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Pacapausa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Pullo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Puyusca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'San Francisco de Ravacayco',
  },
  {
    dep: 'Ayacucho',
    prov: 'Parinacochas',
    dist: 'Upahuacho',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Pausa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Colta',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Corculla',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Lampa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Marcabamba',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Oyolo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Pararca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'San Javier de Alpabamba',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'San Jose de Ushua',
  },
  {
    dep: 'Ayacucho',
    prov: 'Paucar del Sara Sara',
    dist: 'Sara Sara',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Querobamba',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Belen',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Chalcos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Chilcayoc',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Huacaña',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Morcolla',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Paico',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'San Pedro de Larcay',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'San Salvador de Quije',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Santiago de Paucaray',
  },
  {
    dep: 'Ayacucho',
    prov: 'Sucre',
    dist: 'Soras',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Huancapi',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Alcamenca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Apongo',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Asquipata',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Canaria',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Cayara',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Colca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Huamanquiquia',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Huancaraylla',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Huaya',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Sarhua',
  },
  {
    dep: 'Ayacucho',
    prov: 'Victor Fajardo',
    dist: 'Vilcanchos',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Vilcas Huaman',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Accomarca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Carhuanca',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Concepcion',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Huambalpa',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Independencia',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Saurama',
  },
  {
    dep: 'Ayacucho',
    prov: 'Vilcas Huaman',
    dist: 'Vischongo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Cajamarca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Asuncion',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Chetilla',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Cospan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Encañada',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Jesus',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Llacanora',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Los Baños del Inca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Magdalena',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Matara',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'Namora',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajamarca',
    dist: 'San Juan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajabamba',
    dist: 'Cajabamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajabamba',
    dist: 'Cachachi',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajabamba',
    dist: 'Condebamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cajabamba',
    dist: 'Sitacocha',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Celendin',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Chumuch',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Cortegana',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Huasmin',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Jorge Chavez',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Jose Galvez',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Miguel Iglesias',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Oxamarca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Sorochuco',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Sucre',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'Utco',
  },
  {
    dep: 'Cajamarca',
    prov: 'Celendin',
    dist: 'La Libertad de Pallan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Chota',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Anguia',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Chadin',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Chiguirip',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Chimban',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Choropampa',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Cochabamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Conchan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Huambos',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Lajas',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Llama',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Miracosta',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Paccha',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Pion',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Querocoto',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'San Juan de Licupis',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Tacabamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Tocmoche',
  },
  {
    dep: 'Cajamarca',
    prov: 'Chota',
    dist: 'Calamarca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Contumaza',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Chilete',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Cupisnique',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Guzmango',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'San Benito',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Santa Cruz de Toled',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Tantarica',
  },
  {
    dep: 'Cajamarca',
    prov: 'Contumaza',
    dist: 'Yonan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Cutervo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Callayuc',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Choros',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Cujillo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'La Ramada',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Pimpingos',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Querocotillo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'San Andres de Cutervo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'San Juan de Cutervo',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'San Luis de Lucma',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Santa Cruz',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Santo Domingo de la Capilla',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Santo Tomas',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Socota',
  },
  {
    dep: 'Cajamarca',
    prov: 'Cutervo',
    dist: 'Toribio Casanova',
  },
  {
    dep: 'Cajamarca',
    prov: 'Hualgayoc',
    dist: 'Bambamarca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Hualgayoc',
    dist: 'Chugur',
  },
  {
    dep: 'Cajamarca',
    prov: 'Hualgayoc',
    dist: 'Hualgayoc',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Jaen',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Bellavista',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Chontali',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Colasay',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Huabal',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Las Pirias',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Pomahuaca',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Pucara',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Sallique',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'San Felipe',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'San Jose del Alto',
  },
  {
    dep: 'Cajamarca',
    prov: 'Jaen',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'San Ignacio',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'Chirinos',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'Huarango',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'La Coipa',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'Namballe',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'San Jose de Lourdes',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Ignacio',
    dist: 'Tabaconas',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Pedro Galvez',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Chancay',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Eduardo Villanueva',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Gregorio Pita',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Ichocan',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Jose Manuel Quiroz',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Marcos',
    dist: 'Jose Sabogal',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'San Miguel',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Bolivar',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Calquis',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Catilluc',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'El Prado',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'La Florida',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Llapa',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Nanchoc',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Niepos',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'San Gregorio',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'San Silvestre de Cochan',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Tongod',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Miguel',
    dist: 'Union Agua Blanca',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Pablo',
    dist: 'San Pablo',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Pablo',
    dist: 'San Bernardino',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Pablo',
    dist: 'San Luis',
  },
  {
    dep: 'Cajamarca',
    prov: 'San Pablo',
    dist: 'Tumbaden',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Santa Cruz',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Andabamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Catache',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Chancaybaños',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'La Esperanza',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Ninabamba',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Pulan',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Saucepampa',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Sexi',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Uticyacu',
  },
  {
    dep: 'Cajamarca',
    prov: 'Santa Cruz',
    dist: 'Yauyucan',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'Callao',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'Bellavista',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'Carmen de La Legua-Reynoso',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'La Perla',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'La Punta',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'Ventanilla',
  },
  {
    dep: 'Callao',
    prov: 'Prov. Const. del Callao',
    dist: 'Mi Peru',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Cusco',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Ccorca',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Poroy',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'San Jeronimo',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'San Sebastian',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Santiago',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Saylla',
  },
  {
    dep: 'Cusco',
    prov: 'Cusco',
    dist: 'Wanchaq',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Acomayo',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Acopia',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Acos',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Mosoc Llacta',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Pomacanchi',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Rondocan',
  },
  {
    dep: 'Cusco',
    prov: 'Acomayo',
    dist: 'Sangarara',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Anta',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Ancahuasi',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Cachimayo',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Chinchaypujio',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Huarocondo',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Limatambo',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Mollepata',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Pucyura',
  },
  {
    dep: 'Cusco',
    prov: 'Anta',
    dist: 'Zurite',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Calca',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Coya',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Lamay',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Lares',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Pisac',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'San Salvador',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Taray',
  },
  {
    dep: 'Cusco',
    prov: 'Calca',
    dist: 'Yanatile',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Yanaoca',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Checca',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Kunturkanki',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Langui',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Layo',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Pampamarca',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Quehue',
  },
  {
    dep: 'Cusco',
    prov: 'Canas',
    dist: 'Tupac Amaru',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Sicuani',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Checacupe',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Combapata',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Marangani',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Pitumarca',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'San Pablo',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'San Pedro',
  },
  {
    dep: 'Cusco',
    prov: 'Canchis',
    dist: 'Tinta',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Santo Tomas',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Capacmarca',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Chamaca',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Colquemarca',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Livitaca',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Llusco',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Quiñota',
  },
  {
    dep: 'Cusco',
    prov: 'Chumbivilcas',
    dist: 'Velille',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Yauri',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Condoroma',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Coporaque',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Ocoruro',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Pallpata',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Pichigua',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Suyckutambo',
  },
  {
    dep: 'Cusco',
    prov: 'Espinar',
    dist: 'Alto Pichigua',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Santa Ana',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Echarate',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Huayopata',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Maranura',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Ocobamba',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Quellouno',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Kimbiri',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Santa Teresa',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Vilcabamba',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Pichari',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Inkawasi',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Villa Virgen',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Villa Kintiarina',
  },
  {
    dep: 'Cusco',
    prov: 'La Convencion',
    dist: 'Megantoni',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Paruro',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Accha',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Ccapi',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Colcha',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Huanoquite',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Omacha',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Paccaritambo',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Pillpinto',
  },
  {
    dep: 'Cusco',
    prov: 'Paruro',
    dist: 'Yaurisque',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Paucartambo',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Caicay',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Challabamba',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Colquepata',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Huancarani',
  },
  {
    dep: 'Cusco',
    prov: 'Paucartambo',
    dist: 'Kosñipata',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Urcos',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Andahuaylillas',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Camanti',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Ccarhuayo',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Ccatca',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Cusipata',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Huaro',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Lucre',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Marcapata',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Ocongate',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Oropesa',
  },
  {
    dep: 'Cusco',
    prov: 'Quispicanchi',
    dist: 'Quiquijana',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Urubamba',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Chinchero',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Huayllabamba',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Machupicchu',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Maras',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Ollantaytambo',
  },
  {
    dep: 'Cusco',
    prov: 'Urubamba',
    dist: 'Yucay',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Huancavelica',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Acobambilla',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Acoria',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Conayca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Cuenca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Huachocolpa',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Huando',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Huayllahuara',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Izcuchaca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Laria',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Manta',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Mariscal Caceres',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Moya',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Nuevo Occoro',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Palca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Pilchaca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Vilca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Yauli',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huancavelica',
    dist: 'Ascension',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Acobamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Andabamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Anta',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Caja',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Marcas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Paucara',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Pomacocha',
  },
  {
    dep: 'Huancavelica',
    prov: 'Acobamba',
    dist: 'Rosario',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Lircay',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Anchonga',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Callanmarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Ccochaccasa',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Chincho',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Congalla',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Huanca-Huanca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Huayllay Grande',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Julcamarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'San Antonio de Antaparco',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Santo Tomas de Pata',
  },
  {
    dep: 'Huancavelica',
    prov: 'Angaraes',
    dist: 'Secclla',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Castrovirreyna',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Arma',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Aurahua',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Capillas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Chupamarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Cocas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Huachos',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Huamatambo',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Mollepampa',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'San Juan',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Santa Ana',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Tantara',
  },
  {
    dep: 'Huancavelica',
    prov: 'Castrovirreyna',
    dist: 'Ticrapo',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Churcampa',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Anco',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Chinchihuasi',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'El Carmen',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'La Merced',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Locroja',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Paucarbamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'San Miguel de Mayocc',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'San Pedro de Coris',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Pachamarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Churcampa',
    dist: 'Cosme',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Huaytara',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Ayavi',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Cordova',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Huayacundo Arma',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Laramarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Ocoyo',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Pilpichaca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Querco',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Quito-Arma',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'San Antonio de Cusicancha',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'San Francisco de Sangayaico',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'San Isidro',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Santiago de Chocorvos',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Santiago de Quirahuara',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Santo Domingo de Capillas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Huaytara',
    dist: 'Tambo',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Pampas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Acostambo',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Acraquia',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Ahuaycha',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Colcabamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Daniel Hernandez',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Huachocolpa',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Huaribamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Ñahuimpuquio',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Pazos',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Quishuar',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Salcabamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Salcahuasi',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'San Marcos de Rocchac',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Surcubamba',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Tintay Puncu',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Quichuas',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Andaymarca',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Roble',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Pichos',
  },
  {
    dep: 'Huancavelica',
    prov: 'Tayacaja',
    dist: 'Santiago de Tucuma',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Huanuco',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Amarilis',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Chinchao',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Churubamba',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Margos',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Quisqui (Kichki)',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'San Francisco de Cayran',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'San Pedro de Chaulan',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Santa Maria del Valle',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Yarumayo',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Pillco Marca',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'Yacus',
  },
  {
    dep: 'Huanuco',
    prov: 'Huanuco',
    dist: 'San Pablo de Pillao',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Ambo',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Cayna',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Colpas',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Conchamarca',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Huacar',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'San Francisco',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'San Rafael',
  },
  {
    dep: 'Huanuco',
    prov: 'Ambo',
    dist: 'Tomay-Kichwa',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'La Union',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Chuquis',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Marias',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Pachas',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Quivilla',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Ripan',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Shunqui',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Sillapata',
  },
  {
    dep: 'Huanuco',
    prov: 'Dos de Mayo',
    dist: 'Yanas',
  },
  {
    dep: 'Huanuco',
    prov: 'Huacaybamba',
    dist: 'Huacaybamba',
  },
  {
    dep: 'Huanuco',
    prov: 'Huacaybamba',
    dist: 'Canchabamba',
  },
  {
    dep: 'Huanuco',
    prov: 'Huacaybamba',
    dist: 'Cochabamba',
  },
  {
    dep: 'Huanuco',
    prov: 'Huacaybamba',
    dist: 'Pinra',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Llata',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Arancay',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Chavin de Pariarca',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Jacas Grande',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Jircan',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Miraflores',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Monzon',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Puños',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Singa',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Tantamayo',
  },
  {
    dep: 'Huanuco',
    prov: 'Huamalies',
    dist: 'Punchao',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Rupa-Rupa',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Daniel Alomia Robles',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Hermilio Valdizan',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Jose Crespo y Castillo',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Luyando',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Mariano Damaso Beraun',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Pucayacu',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Castillo Grande',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Pueblo Nuevo',
  },
  {
    dep: 'Huanuco',
    prov: 'Leoncio Prado',
    dist: 'Santo Domingo de Anda',
  },
  {
    dep: 'Huanuco',
    prov: 'Marañon',
    dist: 'Huacrachuco',
  },
  {
    dep: 'Huanuco',
    prov: 'Marañon',
    dist: 'Cholon',
  },
  {
    dep: 'Huanuco',
    prov: 'Marañon',
    dist: 'San Buenaventura',
  },
  {
    dep: 'Huanuco',
    prov: 'Marañon',
    dist: 'La Morada',
  },
  {
    dep: 'Huanuco',
    prov: 'Marañon',
    dist: 'Santa Rosa de Alto Yanajanca',
  },
  {
    dep: 'Huanuco',
    prov: 'Pachitea',
    dist: 'Panao',
  },
  {
    dep: 'Huanuco',
    prov: 'Pachitea',
    dist: 'Chaglla',
  },
  {
    dep: 'Huanuco',
    prov: 'Pachitea',
    dist: 'Molino',
  },
  {
    dep: 'Huanuco',
    prov: 'Pachitea',
    dist: 'Umari',
  },
  {
    dep: 'Huanuco',
    prov: 'Puerto Inca',
    dist: 'Puerto Inca',
  },
  {
    dep: 'Huanuco',
    prov: 'Puerto Inca',
    dist: 'Codo del Pozuzo',
  },
  {
    dep: 'Huanuco',
    prov: 'Puerto Inca',
    dist: 'Honoria',
  },
  {
    dep: 'Huanuco',
    prov: 'Puerto Inca',
    dist: 'Tournavista',
  },
  {
    dep: 'Huanuco',
    prov: 'Puerto Inca',
    dist: 'Yuyapichis',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'Jesus',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'Baños',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'Jivia',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'Queropalca',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'Rondos',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'San Francisco de Asis',
  },
  {
    dep: 'Huanuco',
    prov: 'Lauricocha',
    dist: 'San Miguel de Cauri',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Chavinillo',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Cahuac',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Chacabamba',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Aparicio Pomares',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Jacas Chico',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Obas',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Pampamarca',
  },
  {
    dep: 'Huanuco',
    prov: 'Yarowilca',
    dist: 'Choras',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Ica',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'La Tinguiña',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Los Aquijes',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Ocucaje',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Pachacutec',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Parcona',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Pueblo Nuevo',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Salas',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'San Jose de los Molinos',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'San Juan Bautista',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Santiago',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Subtanjalla',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Tate',
  },
  {
    dep: 'Ica',
    prov: 'Ica',
    dist: 'Yauca del Rosario',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Chincha Alta',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Alto Laran',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Chavin',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Chincha Baja',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'El Carmen',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Grocio Prado',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Pueblo Nuevo',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'San Juan de Yanac',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'San Pedro de Huacarpana',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Sunampe',
  },
  {
    dep: 'Ica',
    prov: 'Chincha',
    dist: 'Tambo de Mora',
  },
  {
    dep: 'Ica',
    prov: 'Nazca',
    dist: 'Nazca',
  },
  {
    dep: 'Ica',
    prov: 'Nazca',
    dist: 'Changuillo',
  },
  {
    dep: 'Ica',
    prov: 'Nazca',
    dist: 'El Ingenio',
  },
  {
    dep: 'Ica',
    prov: 'Nazca',
    dist: 'Marcona',
  },
  {
    dep: 'Ica',
    prov: 'Nazca',
    dist: 'Vista Alegre',
  },
  {
    dep: 'Ica',
    prov: 'Palpa',
    dist: 'Palpa',
  },
  {
    dep: 'Ica',
    prov: 'Palpa',
    dist: 'Llipata',
  },
  {
    dep: 'Ica',
    prov: 'Palpa',
    dist: 'Rio Grande',
  },
  {
    dep: 'Ica',
    prov: 'Palpa',
    dist: 'Santa Cruz',
  },
  {
    dep: 'Ica',
    prov: 'Palpa',
    dist: 'Tibillo',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Pisco',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Huancano',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Humay',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Independencia',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Paracas',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'San Andres',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'San Clemente',
  },
  {
    dep: 'Ica',
    prov: 'Pisco',
    dist: 'Tupac Amaru Inca',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Huancayo',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Carhuacallanga',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Chacapampa',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Chicche',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Chilca',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Chongos Alto',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Chupuro',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Colca',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Cullhuas',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'El Tambo',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Huacrapuquio',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Hualhuas',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Huancan',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Huasicancha',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Huayucachi',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Ingenio',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Pariahuanca',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Pilcomayo',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Pucara',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Quichuay',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Quilcas',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'San Agustin',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'San Jeronimo de Tunan',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Saño',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Sapallanga',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Sicaya',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Santo Domingo de Acobamba',
  },
  {
    dep: 'Junin',
    prov: 'Huancayo',
    dist: 'Viques',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Concepcion',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Aco',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Andamarca',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Chambara',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Cochas',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Comas',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Heroinas Toledo',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Manzanares',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Mariscal Castilla',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Matahuasi',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Mito',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Nueve de Julio',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Orcotuna',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'San Jose de Quero',
  },
  {
    dep: 'Junin',
    prov: 'Concepcion',
    dist: 'Santa Rosa de Ocopa',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'La Merced',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'Perene',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'Pichanaqui',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'San Luis de Shuaro',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'San Ramon',
  },
  {
    dep: 'Junin',
    prov: 'Chanchamayo',
    dist: 'Vitoc',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Jauja',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Acolla',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Apata',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Ataura',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Canchayllo',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Curicaca',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'El Mantaro',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Huamali',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Huaripampa',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Huertas',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Janjaillo',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Julcan',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Leonor Ordóñez',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Llocllapampa',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Marco',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Masma',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Masma Chicche',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Molinos',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Monobamba',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Muqui',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Muquiyauyo',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Paca',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Paccha',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Pancan',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Parco',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Pomacancha',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Ricran',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'San Lorenzo',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'San Pedro de Chunan',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Sausa',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Sincos',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Tunan Marca',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Yauli',
  },
  {
    dep: 'Junin',
    prov: 'Jauja',
    dist: 'Yauyos',
  },
  {
    dep: 'Junin',
    prov: 'Junin',
    dist: 'Junin',
  },
  {
    dep: 'Junin',
    prov: 'Junin',
    dist: 'Carhuamayo',
  },
  {
    dep: 'Junin',
    prov: 'Junin',
    dist: 'Ondores',
  },
  {
    dep: 'Junin',
    prov: 'Junin',
    dist: 'Ulcumayo',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Satipo',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Coviriali',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Llaylla',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Mazamari',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Pampa Hermosa',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Pangoa',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Rio Negro',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Rio Tambo',
  },
  {
    dep: 'Junin',
    prov: 'Satipo',
    dist: 'Vizcatan del Ene',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Tarma',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Acobamba',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Huaricolca',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Huasahuasi',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'La Union',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Palca',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Palcamayo',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'San Pedro de Cajas',
  },
  {
    dep: 'Junin',
    prov: 'Tarma',
    dist: 'Tapo',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'La Oroya',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Chacapalpa',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Huay-Huay',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Marcapomacocha',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Morococha',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Paccha',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Santa Barbara de Carhuacayan',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Santa Rosa de Sacco',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Suitucancha',
  },
  {
    dep: 'Junin',
    prov: 'Yauli',
    dist: 'Yauli',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Chupaca',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Ahuac',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Chongos Bajo',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Huachac',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Huamancaca Chico',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'San Juan de Iscos',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'San Juan de Jarpa',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Tres de Diciembre',
  },
  {
    dep: 'Junin',
    prov: 'Chupaca',
    dist: 'Yanacancha',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Trujillo',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'El Porvenir',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Florencia de Mora',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Huanchaco',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'La Esperanza',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Laredo',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Moche',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Poroto',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Salaverry',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Simbal',
  },
  {
    dep: 'La Libertad',
    prov: 'Trujillo',
    dist: 'Victor Larco Herrera',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Ascope',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Chicama',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Chocope',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Magdalena de Cao',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Paijan',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Razuri',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Santiago de Cao',
  },
  {
    dep: 'La Libertad',
    prov: 'Ascope',
    dist: 'Casa Grande',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Bolivar',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Bambamarca',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Condormarca',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Longotea',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Uchumarca',
  },
  {
    dep: 'La Libertad',
    prov: 'Bolivar',
    dist: 'Ucuncha',
  },
  {
    dep: 'La Libertad',
    prov: 'Chepen',
    dist: 'Chepen',
  },
  {
    dep: 'La Libertad',
    prov: 'Chepen',
    dist: 'Pacanga',
  },
  {
    dep: 'La Libertad',
    prov: 'Chepen',
    dist: 'Pueblo Nuevo',
  },
  {
    dep: 'La Libertad',
    prov: 'Julcan',
    dist: 'Julcan',
  },
  {
    dep: 'La Libertad',
    prov: 'Julcan',
    dist: 'Calamarca',
  },
  {
    dep: 'La Libertad',
    prov: 'Julcan',
    dist: 'Carabamba',
  },
  {
    dep: 'La Libertad',
    prov: 'Julcan',
    dist: 'Huaso',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Otuzco',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Agallpampa',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Charat',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Huaranchal',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'La Cuesta',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Mache',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Paranday',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Salpo',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Sinsicap',
  },
  {
    dep: 'La Libertad',
    prov: 'Otuzco',
    dist: 'Usquil',
  },
  {
    dep: 'La Libertad',
    prov: 'Pacasmayo',
    dist: 'San Pedro de Lloc',
  },
  {
    dep: 'La Libertad',
    prov: 'Pacasmayo',
    dist: 'Guadalupe',
  },
  {
    dep: 'La Libertad',
    prov: 'Pacasmayo',
    dist: 'Jequetepeque',
  },
  {
    dep: 'La Libertad',
    prov: 'Pacasmayo',
    dist: 'Pacasmayo',
  },
  {
    dep: 'La Libertad',
    prov: 'Pacasmayo',
    dist: 'San Jose',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Tayabamba',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Buldibuyo',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Chilia',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Huancaspata',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Huaylillas',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Huayo',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Ongon',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Parcoy',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Pataz',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Pias',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Santiago de Challas',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Taurija',
  },
  {
    dep: 'La Libertad',
    prov: 'Pataz',
    dist: 'Urpay',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Huamachuco',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Chugay',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Cochorco',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Curgos',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Marcabal',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Sanagoran',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Sarin',
  },
  {
    dep: 'La Libertad',
    prov: 'Sanchez Carrion',
    dist: 'Sartimbamba',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Santiago de Chuco',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Angasmarca',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Cachicadan',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Mollebamba',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Mollepata',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Quiruvilca',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Santa Cruz de Chuca',
  },
  {
    dep: 'La Libertad',
    prov: 'Santiago de Chuco',
    dist: 'Sitabamba',
  },
  {
    dep: 'La Libertad',
    prov: 'Gran Chimu',
    dist: 'Cascas',
  },
  {
    dep: 'La Libertad',
    prov: 'Gran Chimu',
    dist: 'Lucma',
  },
  {
    dep: 'La Libertad',
    prov: 'Gran Chimu',
    dist: 'Marmot',
  },
  {
    dep: 'La Libertad',
    prov: 'Gran Chimu',
    dist: 'Sayapullo',
  },
  {
    dep: 'La Libertad',
    prov: 'Viru',
    dist: 'Viru',
  },
  {
    dep: 'La Libertad',
    prov: 'Viru',
    dist: 'Chao',
  },
  {
    dep: 'La Libertad',
    prov: 'Viru',
    dist: 'Guadalupito',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Chiclayo',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Chongoyape',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Eten',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Eten Puerto',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Jose Leonardo Ortiz',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'La Victoria',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Lagunas',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Monsefu',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Nueva Arica',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Oyotun',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Picsi',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Pimentel',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Reque',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Saña',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Cayalti',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Patapo',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Pomalca',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Pucala',
  },
  {
    dep: 'Lambayeque',
    prov: 'Chiclayo',
    dist: 'Tuman',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Ferreñafe',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Cañaris',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Incahuasi',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Manuel Antonio Mesones Muro',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Pitipo',
  },
  {
    dep: 'Lambayeque',
    prov: 'Ferreñafe',
    dist: 'Pueblo Nuevo',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Lambayeque',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Chochope',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Illimo',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Jayanca',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Mochumi',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Morrope',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Motupe',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Olmos',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Pacora',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Salas',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'San Jose',
  },
  {
    dep: 'Lambayeque',
    prov: 'Lambayeque',
    dist: 'Tucume',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Lima',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Ancon',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Ate',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Barranco',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Breña',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Carabayllo',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Chaclacayo',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Chorrillos',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Cieneguilla',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Comas',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'El Agustino',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Independencia',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Jesus Maria',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'La Molina',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'La Victoria',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Lince',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Los Olivos',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Lurigancho',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Lurin',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Magdalena del Mar',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Pueblo Libre',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Miraflores',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Pachacamac',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Pucusana',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Puente Piedra',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Punta Hermosa',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Punta Negra',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Rimac',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Bartolo',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Borja',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Isidro',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Juan de Lurigancho',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Juan de Miraflores',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Luis',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Martín de Porres',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'San Miguel',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Santa Anita',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Santa Maria del Mar',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Santiago de Surco',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Surquillo',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Villa El Salvador',
  },
  {
    dep: 'Lima',
    prov: 'Lima',
    dist: 'Villa Maria del Triunfo',
  },
  {
    dep: 'Lima',
    prov: 'Barranca',
    dist: 'Barranca',
  },
  {
    dep: 'Lima',
    prov: 'Barranca',
    dist: 'Paramonga',
  },
  {
    dep: 'Lima',
    prov: 'Barranca',
    dist: 'Pativilca',
  },
  {
    dep: 'Lima',
    prov: 'Barranca',
    dist: 'Supe',
  },
  {
    dep: 'Lima',
    prov: 'Barranca',
    dist: 'Supe Puerto',
  },
  {
    dep: 'Lima',
    prov: 'Cajatambo',
    dist: 'Cajatambo',
  },
  {
    dep: 'Lima',
    prov: 'Cajatambo',
    dist: 'Copa',
  },
  {
    dep: 'Lima',
    prov: 'Cajatambo',
    dist: 'Gorgor',
  },
  {
    dep: 'Lima',
    prov: 'Cajatambo',
    dist: 'Huancapon',
  },
  {
    dep: 'Lima',
    prov: 'Cajatambo',
    dist: 'Manas',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Canta',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Arahuay',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Huanza',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Huaros',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Lachaqui',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'San Buenaventura',
  },
  {
    dep: 'Lima',
    prov: 'Canta',
    dist: 'Santa Rosa de Quives',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'San Vicente de Cañete',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Asia',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Calango',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Cerro Azul',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Chilca',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Coayllo',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Imperial',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Lunahuana',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Mala',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Nuevo Imperial',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Pacaran',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Quilmana',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'San Antonio',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'San Luis',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Santa Cruz de Flores',
  },
  {
    dep: 'Lima',
    prov: 'Cañete',
    dist: 'Zúñiga',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Huaral',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Atavillos Alto',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Atavillos Bajo',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Aucallama',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Chancay',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Ihuari',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Lampian',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Pacaraos',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'San Miguel de Acos',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Santa Cruz de Andamarca',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Sumbilca',
  },
  {
    dep: 'Lima',
    prov: 'Huaral',
    dist: 'Veintisiete de Noviembre',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Matucana',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Antioquia',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Callahuanca',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Carampoma',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Chicla',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Cuenca',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Huanza',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Huarochiri',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Lahuaytambo',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Langa',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Laraos',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Mariatana',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Ricardo Palma',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Andres de Tupicocha',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Antonio',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Bartolome',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Damian',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Juan de Iris',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Juan de Tantaranche',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Lorenzo de Quinti',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Mateo',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Mateo de Otao',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Pedro de Casta',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Pedro de Huancayre',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Sangallaya',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Santa Cruz de Cocachacra',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Santa Eulalia',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Santiago de Anchucaya',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Santiago de Tuna',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Santo Domingo de los Olleros',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'San Jeronimo de Surco',
  },
  {
    dep: 'Lima',
    prov: 'Huarochiri',
    dist: 'Songos',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Huacho',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Ambar',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Caleta de Carquin',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Checras',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Hualmay',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Huaura',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Leoncio Prado',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Paccho',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Santa Leonor',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Santa Maria',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Sayan',
  },
  {
    dep: 'Lima',
    prov: 'Huaura',
    dist: 'Vegueta',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Oyon',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Andajes',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Caujul',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Cochamarca',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Navan',
  },
  {
    dep: 'Lima',
    prov: 'Oyon',
    dist: 'Pachangara',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Yauyos',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Alis',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Ayauca',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Ayaviri',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Azangaro',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Cacra',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Carania',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Catahuasi',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Chocos',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Cochas',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Colonia',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Hongos',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Huampara',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Huancaya',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Huangascar',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Huantan',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Huañec',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Laraos',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Lincha',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Madean',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Miraflores',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Omas',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Putinza',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Quinches',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Quinocay',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'San Joaquin',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'San Pedro de Pilas',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Tanta',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Tauripampa',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Tomas',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Tupe',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Viñac',
  },
  {
    dep: 'Lima',
    prov: 'Yauyos',
    dist: 'Vitis',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Iquitos',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Alto Nanay',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Fernando Lores',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Indiana',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Las Amazonas',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Mazan',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Napo',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Punchana',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Torres Causana',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'Belen',
  },
  {
    dep: 'Loreto',
    prov: 'Maynas',
    dist: 'San Juan Bautista',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Yurimaguas',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Balsapuerto',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Jeberos',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Lagunas',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Santa Cruz',
  },
  {
    dep: 'Loreto',
    prov: 'Alto Amazonas',
    dist: 'Teniente Cesar Lopez Rojas',
  },
  {
    dep: 'Loreto',
    prov: 'Loreto',
    dist: 'Nauta',
  },
  {
    dep: 'Loreto',
    prov: 'Loreto',
    dist: 'Parinari',
  },
  {
    dep: 'Loreto',
    prov: 'Loreto',
    dist: 'Tigre',
  },
  {
    dep: 'Loreto',
    prov: 'Loreto',
    dist: 'Trompeteros',
  },
  {
    dep: 'Loreto',
    prov: 'Loreto',
    dist: 'Urarinas',
  },
  {
    dep: 'Loreto',
    prov: 'Mariscal Ramon Castilla',
    dist: 'Ramon Castilla',
  },
  {
    dep: 'Loreto',
    prov: 'Mariscal Ramon Castilla',
    dist: 'Pebas',
  },
  {
    dep: 'Loreto',
    prov: 'Mariscal Ramon Castilla',
    dist: 'Yavari',
  },
  {
    dep: 'Loreto',
    prov: 'Mariscal Ramon Castilla',
    dist: 'San Pablo',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Requena',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Alto Tapiche',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Capelo',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Emilio San Martín',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Maquia',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Puinahua',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Saquena',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Soplin',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Tapiche',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Jenaro Herrera',
  },
  {
    dep: 'Loreto',
    prov: 'Requena',
    dist: 'Yaquerana',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Contamana',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Inahuaya',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Padre Marquez',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Pampa Hermosa',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Sarayacu',
  },
  {
    dep: 'Loreto',
    prov: 'Ucayali',
    dist: 'Vargas Guerra',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Barranca',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Cahuapanas',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Manseriche',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Morona',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Pastaza',
  },
  {
    dep: 'Loreto',
    prov: 'Datem del Marañon',
    dist: 'Andoas',
  },
  {
    dep: 'Loreto',
    prov: 'Putumayo',
    dist: 'Putumayo',
  },
  {
    dep: 'Loreto',
    prov: 'Putumayo',
    dist: 'Rosa Panduro',
  },
  {
    dep: 'Loreto',
    prov: 'Putumayo',
    dist: 'Teniente Manuel Clavero',
  },
  {
    dep: 'Loreto',
    prov: 'Putumayo',
    dist: 'Yaguas',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tambopata',
    dist: 'Tambopata',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tambopata',
    dist: 'Inambari',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tambopata',
    dist: 'Las Piedras',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tambopata',
    dist: 'Laberinto',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Manu',
    dist: 'Manu',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Manu',
    dist: 'Fitzcarrald',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Manu',
    dist: 'Madre de Dios',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Manu',
    dist: 'Huepetuhe',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tahuamanu',
    dist: 'Iñapari',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tahuamanu',
    dist: 'Iberia',
  },
  {
    dep: 'Madre de Dios',
    prov: 'Tahuamanu',
    dist: 'Tahuamanu',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'Moquegua',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'Carumas',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'Cuchumbaya',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'Samegua',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'San Cristobal',
  },
  {
    dep: 'Moquegua',
    prov: 'Mariscal Nieto',
    dist: 'Torata',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Omate',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Chojata',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Coalaque',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Ichuña',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'La Capilla',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Lloque',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Matalaque',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Puquina',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Quinistaquillas',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Ubinas',
  },
  {
    dep: 'Moquegua',
    prov: 'General Sanchez Cerro',
    dist: 'Yunga',
  },
  {
    dep: 'Moquegua',
    prov: 'Ilo',
    dist: 'Ilo',
  },
  {
    dep: 'Moquegua',
    prov: 'Ilo',
    dist: 'El Algarrobal',
  },
  {
    dep: 'Moquegua',
    prov: 'Ilo',
    dist: 'Pacocha',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Chaupimarca',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Huachon',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Huariaca',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Huayllay',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Ninacaca',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Pallanchacra',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Paucartambo',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'San Francisco de Asis de Yarusyacan',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Simon Bolivar',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Ticlacayan',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Tinyahuarco',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Vicco',
  },
  {
    dep: 'Pasco',
    prov: 'Pasco',
    dist: 'Yanacancha',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Yanahuanca',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Chacayan',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Goyllarisquizga',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Paucar',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'San Pedro de Pillao',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Santa Ana de Tusi',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Tapuc',
  },
  {
    dep: 'Pasco',
    prov: 'Daniel Alcides Carrion',
    dist: 'Vilcabamba',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Oxapampa',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Chontabamba',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Huancabamba',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Palcazu',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Pozuzo',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Puerto Bermudez',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Villa Rica',
  },
  {
    dep: 'Pasco',
    prov: 'Oxapampa',
    dist: 'Constitucion',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Piura',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Castilla',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Catacaos',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Cura Mori',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'El Tallan',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'La Arena',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'La Union',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Las Lomas',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Tambo Grande',
  },
  {
    dep: 'Piura',
    prov: 'Piura',
    dist: 'Veintiseis de Octubre',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Ayabaca',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Frias',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Jilili',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Lagunas',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Montero',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Pacaipampa',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Paimas',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Sapillica',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Sicchez',
  },
  {
    dep: 'Piura',
    prov: 'Ayabaca',
    dist: 'Suyo',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Huancabamba',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Canchaque',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'El Carmen de la Frontera',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Huarmaca',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Lalaquiz',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'San Miguel de El Faique',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Sondor',
  },
  {
    dep: 'Piura',
    prov: 'Huancabamba',
    dist: 'Sondorillo',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Chulucanas',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Buenos Aires',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Chalaco',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'La Matanza',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Morropon',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Salitral',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'San Juan de Bigote',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Santa Catalina de Mossa',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Santo Domingo',
  },
  {
    dep: 'Piura',
    prov: 'Morropon',
    dist: 'Yamango',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Paita',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Amotape',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Arenal',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Colan',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'La Huaca',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Tamarindo',
  },
  {
    dep: 'Piura',
    prov: 'Paita',
    dist: 'Vichayal',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Sullana',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Bellavista',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Ignacio Escudero',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Lancones',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Marcavelica',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Miguel Checa',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Querecotillo',
  },
  {
    dep: 'Piura',
    prov: 'Sullana',
    dist: 'Salitral',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'Pariñas',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'El Alto',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'La Brea',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'Lobitos',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'Los Organos',
  },
  {
    dep: 'Piura',
    prov: 'Talara',
    dist: 'Mancora',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Sechura',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Bellavista de la Union',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Bernal',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Cristo Nos Valga',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Vice',
  },
  {
    dep: 'Piura',
    prov: 'Sechura',
    dist: 'Rinconada Llicuar',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Puno',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Acora',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Amantani',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Atuncolla',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Capachica',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Chucuito',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Coata',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Huata',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Mañazo',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Paucarcolla',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Pichacani',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Plateria',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'San Antonio',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Tiquillaca',
  },
  {
    dep: 'Puno',
    prov: 'Puno',
    dist: 'Vilque',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Azangaro',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Achaya',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Arapa',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Asillo',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Caminaca',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Chupa',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Jose Domingo Choquehuanca',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Muñani',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Potoni',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Saman',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'San Anton',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'San Jose',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'San Juan de Salinas',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Santiago de Pupuja',
  },
  {
    dep: 'Puno',
    prov: 'Azangaro',
    dist: 'Tirapata',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Macusani',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Ajoyani',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Ayapata',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Coasa',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Corani',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Crucero',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Ituata',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Ollachea',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'San Gaban',
  },
  {
    dep: 'Puno',
    prov: 'Carabaya',
    dist: 'Usicayos',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Juli',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Desaguadero',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Huacullani',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Kelluyo',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Pisacoma',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Pomata',
  },
  {
    dep: 'Puno',
    prov: 'Chucuito',
    dist: 'Zepita',
  },
  {
    dep: 'Puno',
    prov: 'El Collao',
    dist: 'Ilave',
  },
  {
    dep: 'Puno',
    prov: 'El Collao',
    dist: 'Capazo',
  },
  {
    dep: 'Puno',
    prov: 'El Collao',
    dist: 'Pilcuyo',
  },
  {
    dep: 'Puno',
    prov: 'El Collao',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Puno',
    prov: 'El Collao',
    dist: 'Conduriri',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Huancane',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Cojata',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Huatasani',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Inchupalla',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Pusi',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Rosaspata',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Taraco',
  },
  {
    dep: 'Puno',
    prov: 'Huancane',
    dist: 'Vilque Chico',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Lampa',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Cabanilla',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Calapuja',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Nicasio',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Ocuviri',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Palca',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Paratia',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Pucara',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Santa Lucia',
  },
  {
    dep: 'Puno',
    prov: 'Lampa',
    dist: 'Vilavila',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Ayaviri',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Antauta',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Cupi',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Llalli',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Macari',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Nuñoa',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Orurillo',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Santa Rosa',
  },
  {
    dep: 'Puno',
    prov: 'Melgar',
    dist: 'Umachiri',
  },
  {
    dep: 'Puno',
    prov: 'Moho',
    dist: 'Moho',
  },
  {
    dep: 'Puno',
    prov: 'Moho',
    dist: 'Conima',
  },
  {
    dep: 'Puno',
    prov: 'Moho',
    dist: 'Huayrapata',
  },
  {
    dep: 'Puno',
    prov: 'Moho',
    dist: 'Tilali',
  },
  {
    dep: 'Puno',
    prov: 'San Antonio de Putina',
    dist: 'Putina',
  },
  {
    dep: 'Puno',
    prov: 'San Antonio de Putina',
    dist: 'Ananea',
  },
  {
    dep: 'Puno',
    prov: 'San Antonio de Putina',
    dist: 'Pedro Vilca Apaza',
  },
  {
    dep: 'Puno',
    prov: 'San Antonio de Putina',
    dist: 'Quilcapuncu',
  },
  {
    dep: 'Puno',
    prov: 'San Antonio de Putina',
    dist: 'Sina',
  },
  {
    dep: 'Puno',
    prov: 'San Roman',
    dist: 'Juliaca',
  },
  {
    dep: 'Puno',
    prov: 'San Roman',
    dist: 'Cabana',
  },
  {
    dep: 'Puno',
    prov: 'San Roman',
    dist: 'Cabanillas',
  },
  {
    dep: 'Puno',
    prov: 'San Roman',
    dist: 'Caracoto',
  },
  {
    dep: 'Puno',
    prov: 'San Roman',
    dist: 'San Miguel',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Sandia',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Cuyocuyo',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Limbani',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Patambuco',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Phara',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Quiaca',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'San Juan del Oro',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Yanahuaya',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'Alto Inambari',
  },
  {
    dep: 'Puno',
    prov: 'Sandia',
    dist: 'San Pedro de Putina Punco',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Yunguyo',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Anapia',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Copani',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Cuturapi',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Ollaraya',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Tinicachi',
  },
  {
    dep: 'Puno',
    prov: 'Yunguyo',
    dist: 'Unicachi',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Moyobamba',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Calzada',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Habana',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Jepelacio',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Soritor',
  },
  {
    dep: 'San Martín',
    prov: 'Moyobamba',
    dist: 'Yantalo',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'Bellavista',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'Alto Biavo',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'Bajo Biavo',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'Huallaga',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'San Pablo',
  },
  {
    dep: 'San Martín',
    prov: 'Bellavista',
    dist: 'San Rafael',
  },
  {
    dep: 'San Martín',
    prov: 'El Dorado',
    dist: 'San Jose de Sisa',
  },
  {
    dep: 'San Martín',
    prov: 'El Dorado',
    dist: 'Agua Blanca',
  },
  {
    dep: 'San Martín',
    prov: 'El Dorado',
    dist: 'San Martín',
  },
  {
    dep: 'San Martín',
    prov: 'El Dorado',
    dist: 'Santa Rosa',
  },
  {
    dep: 'San Martín',
    prov: 'El Dorado',
    dist: 'Shatoja',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'Saposoa',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'Alto Saposoa',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'El Eslabon',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'Piscoyacu',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'Sacanche',
  },
  {
    dep: 'San Martín',
    prov: 'Huallaga',
    dist: 'Tingo de Saposoa',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Lamas',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Alonso de Alvarado',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Barranquita',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Caynarachi',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Cuñumbuqui',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Pinto Recodo',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Rumisapa',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'San Roque de Cumbaza',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Shanao',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Tabalosos',
  },
  {
    dep: 'San Martín',
    prov: 'Lamas',
    dist: 'Zapatero',
  },
  {
    dep: 'San Martín',
    prov: 'Mariscal Caceres',
    dist: 'Juanjui',
  },
  {
    dep: 'San Martín',
    prov: 'Mariscal Caceres',
    dist: 'Campanilla',
  },
  {
    dep: 'San Martín',
    prov: 'Mariscal Caceres',
    dist: 'Huicungo',
  },
  {
    dep: 'San Martín',
    prov: 'Mariscal Caceres',
    dist: 'Pachiza',
  },
  {
    dep: 'San Martín',
    prov: 'Mariscal Caceres',
    dist: 'Pajarillo',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Picota',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Buenos Aires',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Caspisapa',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Pilluana',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Pucacaca',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'San Cristobal',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'San Hilarion',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Shamboyacu',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Tingo de Ponasa',
  },
  {
    dep: 'San Martín',
    prov: 'Picota',
    dist: 'Tres Unidos',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Rioja',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Awajun',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Elias Soplin Vargas',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Nueva Cajamarca',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Pardo Miguel',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Posic',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'San Fernando',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Yorongos',
  },
  {
    dep: 'San Martín',
    prov: 'Rioja',
    dist: 'Yuracyacu',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Tarapoto',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Alberto Leveau',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Cacatachi',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Chazuta',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Chipurana',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'El Porvenir',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Huimbayoc',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Juan Guerra',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'La Banda de Shilcayo',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Morales',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Papaplaya',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'San Antonio',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Sauce',
  },
  {
    dep: 'San Martín',
    prov: 'San Martín',
    dist: 'Shapaja',
  },
  {
    dep: 'San Martín',
    prov: 'Tocache',
    dist: 'Tocache',
  },
  {
    dep: 'San Martín',
    prov: 'Tocache',
    dist: 'Nuevo Progreso',
  },
  {
    dep: 'San Martín',
    prov: 'Tocache',
    dist: 'Polvora',
  },
  {
    dep: 'San Martín',
    prov: 'Tocache',
    dist: 'Shunte',
  },
  {
    dep: 'San Martín',
    prov: 'Tocache',
    dist: 'Uchiza',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Tacna',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Alto de la Alianza',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Calana',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Ciudad Nueva',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Coronel Gregorio Albarracin Lanchipa',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Inclan',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Pachia',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Palca',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Pocollay',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'Sama',
  },
  {
    dep: 'Tacna',
    prov: 'Tacna',
    dist: 'La Yarada los Palos',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Candarave',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Cairani',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Camilaca',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Curibaya',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Huanuara',
  },
  {
    dep: 'Tacna',
    prov: 'Candarave',
    dist: 'Quilahuani',
  },
  {
    dep: 'Tacna',
    prov: 'Jorge Basadre',
    dist: 'Locumba',
  },
  {
    dep: 'Tacna',
    prov: 'Jorge Basadre',
    dist: 'Ilabaya',
  },
  {
    dep: 'Tacna',
    prov: 'Jorge Basadre',
    dist: 'Ite',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Tarata',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Chucatamani',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Estique',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Estique-Pampa',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Sitajara',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Susapaya',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Tarucachi',
  },
  {
    dep: 'Tacna',
    prov: 'Tarata',
    dist: 'Ticaco',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'Tumbes',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'Corrales',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'La Cruz',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'Pampas de Hospital',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'San Jacinto',
  },
  {
    dep: 'Tumbes',
    prov: 'Tumbes',
    dist: 'San Juan de la Virgen',
  },
  {
    dep: 'Tumbes',
    prov: 'Contralmirante Villar',
    dist: 'Zorritos',
  },
  {
    dep: 'Tumbes',
    prov: 'Contralmirante Villar',
    dist: 'Casitas',
  },
  {
    dep: 'Tumbes',
    prov: 'Contralmirante Villar',
    dist: 'Canoas de Punta Sal',
  },
  {
    dep: 'Tumbes',
    prov: 'Zarumilla',
    dist: 'Zarumilla',
  },
  {
    dep: 'Tumbes',
    prov: 'Zarumilla',
    dist: 'Aguas Verdes',
  },
  {
    dep: 'Tumbes',
    prov: 'Zarumilla',
    dist: 'Matapalo',
  },
  {
    dep: 'Tumbes',
    prov: 'Zarumilla',
    dist: 'Papayal',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Calleria',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Campoverde',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Iparia',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Masisea',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Yarinacocha',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Nueva Requena',
  },
  {
    dep: 'Ucayali',
    prov: 'Coronel Portillo',
    dist: 'Manantay',
  },
  {
    dep: 'Ucayali',
    prov: 'Atalaya',
    dist: 'Raimondi',
  },
  {
    dep: 'Ucayali',
    prov: 'Atalaya',
    dist: 'Sepahua',
  },
  {
    dep: 'Ucayali',
    prov: 'Atalaya',
    dist: 'Tahuania',
  },
  {
    dep: 'Ucayali',
    prov: 'Atalaya',
    dist: 'Yurua',
  },
  {
    dep: 'Ucayali',
    prov: 'Padre Abad',
    dist: 'Padre Abad',
  },
  {
    dep: 'Ucayali',
    prov: 'Padre Abad',
    dist: 'Irazola',
  },
  {
    dep: 'Ucayali',
    prov: 'Padre Abad',
    dist: 'Curimana',
  },
  {
    dep: 'Ucayali',
    prov: 'Padre Abad',
    dist: 'Neshuya',
  },
  {
    dep: 'Ucayali',
    prov: 'Padre Abad',
    dist: 'Alexander Von Humboldt',
  },
  {
    dep: 'Ucayali',
    prov: 'Purus',
    dist: 'Purus',
  },
];
